import React from 'react'

const ShipmentPlanning = () => {
  return (
    <div>ShipmentPlanning</div>
  )
}

export default ShipmentPlanning